import { termsConfig } from "@/types/adaptation";
import { formatAbbreviatedValueWithMetricUnit } from "@/utils/number";
import { TrophyIcon } from "@phosphor-icons/react/dist/ssr";
import React from "react";
import { useTranslation } from "react-i18next";
import { DeltaValue } from "./common/Text";
const AdaptationDumbbellTooltip = ({
  active,
  payload,
  startLabel,
  endLabel,
  startColor,
  endColor,
  unit,
  footer,
  label
}: {
  active?: boolean;
  payload?: any[];
  startLabel: string;
  endLabel: string;
  startColor: string;
  endColor: string;
  unit: "%" | "$";
  footer?: React.ReactNode;
  label: string;
}) => {
  const {
    t
  } = useTranslation("terms");
  if (!active || !payload?.length) return null;
  const {
    name,
    start,
    end,
    isTopDecile
  } = payload[0].payload as {
    name: string;
    start: number;
    end: number;
    isTopDecile?: boolean;
  };
  return <div className="grid gap-x-2 rounded-lg border border-gray-200 bg-surface/80 p-3 text-sm text-gray-700 shadow-lg backdrop-blur backdrop-saturate-200" style={{
    gridTemplateColumns: "minmax(72px, auto) auto auto"
  }} data-sentry-component="AdaptationDumbbellTooltip" data-sentry-source-file="AdaptationDumbellTooltip.tsx">
      <span className="col-span-3 mb-1 text-sm font-semibold tabular-nums">{name}</span>

      {isTopDecile && <div className="col-span-3 mb-2 flex items-center gap-1 text-xs font-semibold" style={{
      color: termsConfig.absoluteChange.color
    }}>
          <TrophyIcon size={14} weight="fill" />
          {t("topDecileAbsoluteChange")}
        </div>}

      <span>{startLabel}</span>
      <span className="text-right font-semibold" style={{
      color: startColor
    }}>
        {formatAbbreviatedValueWithMetricUnit(start, unit)}
      </span>
      <span>{label}</span>

      <span>{endLabel}</span>
      <span className="text-right font-semibold" style={{
      color: endColor
    }}>
        {formatAbbreviatedValueWithMetricUnit(end, unit)}
      </span>
      <span>{label}</span>

      <span>{t("relativeChange")}</span>
      <div className="col-span-1 col-start-2 flex items-center justify-end gap-1 text-right font-semibold italic" style={{
      color: termsConfig.relativeChange.color
    }}>
        <DeltaValue mode="relativeChange" unit={unit} baseline={start} compare={end} data-sentry-element="DeltaValue" data-sentry-source-file="AdaptationDumbellTooltip.tsx" />
      </div>
      <span></span>
      <span>{t("absoluteChange")}</span>
      <div className="col-span-1 col-start-2 flex items-center justify-end gap-1 text-right font-semibold italic" style={{
      color: termsConfig.absoluteChange.color
    }}>
        <DeltaValue mode="absoluteChange" unit={unit} baseline={start} compare={end} data-sentry-element="DeltaValue" data-sentry-source-file="AdaptationDumbellTooltip.tsx" />
      </div>
      <span></span>

      {footer && <div className="col-span-3 mt-2 border-t border-gray-100 pt-1">{footer}</div>}
    </div>;
};
export default AdaptationDumbbellTooltip;